export const ALL_DISPATCH_ORDER_REQUEST = "ALL_DISPATCH_ORDER_REQUEST";
export const ALL_DISPATCH_ORDER_SUCCESS = "ALL_DISPATCH_ORDER_SUCCESS";
export const ALL_DISPATCH_ORDER_FAIL = "ALL_DISPATCH_ORDER_FAIL"